import { Outlet } from 'react-router-dom';
import React, { Suspense, useEffect, useState } from 'react';
const Navbar = React.lazy(() => import('../components/Navbar'));
const Footer = React.lazy(() => import('../components/Footer'));
import { useAuthentication } from '../hooks/useAuthentication';
import { redirectToLogin } from '@/utils/redirect';

import {
  FIND_USER_BY_ID_V5,
  FindUsersPermissionsUserByIdV5Query,
  FindUsersPermissionsUserByIdV5QueryVariables,
} from '@edwin-group/cj-graphql';
import { ApolloError, useQuery } from '@apollo/client';
import { loginTracker } from '@/services/auth/auth.service';
// import { allowedRoutes } from './utils';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function ProtectedLayout() {
  const { authentication, updateUserContext } = useAuthentication();
  const [alreadyLogged, setAlreadyLogged] = useState(false);

  const userPoolInterval = 60 * 1000 * 5; //5 minutes

  useQuery<FindUsersPermissionsUserByIdV5Query, FindUsersPermissionsUserByIdV5QueryVariables>(FIND_USER_BY_ID_V5, {
    variables: { documentId: authentication?.user?.documentId || '' },
    fetchPolicy: 'network-only',
    pollInterval: userPoolInterval,
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => updateUserContext(data),
    onError: handleError,
  });

  useEffect(() => {
    if (!authentication?.user || alreadyLogged) {
      return;
    }

    loginTracker(authentication?.user?.documentId);

    setAlreadyLogged(true);
  }, [authentication?.user, alreadyLogged]);

  function handleError(error: ApolloError) {
    if (
      error?.message === 'UNAUTHENTICATED' ||
      error?.message === 'Forbidden access' ||
      error?.message?.includes('401')
    ) {
      redirectToLogin();
    }
    console.error(error.message);
  }

  // const location = useLocation();
  // const showBackground =
  //   allowedRoutes.some((route) => location.pathname.startsWith(route)) || location.pathname === '/';

  if (!authentication?.isAuthenticated) {
    redirectToLogin();
    return null;
  }

  return (
    <Suspense
      fallback={
        <div className="w-full">
          <div className="flex h-screen flex-col items-center justify-center">
            <img src="/loading_logo.png" alt="logo" className="animate-spin-slow size-20" />
            {/* <p className="mt-5 font-cadiz text-sh-sm">Loading...</p> */}
            {/* <div className="mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600"></div> */}
          </div>
        </div>
      }>
      <div style={{ backgroundImage: 'url(/background-home.svg)' }}>
        {authentication?.user.onboardHomeCompleted && <Navbar />}
        <div className="h-full min-h-screen">
          <Outlet />
        </div>
        {authentication?.user.onboardHomeCompleted && <Footer />}
      </div>
    </Suspense>
  );
}
